/**
 * Every API path in one place, relative to `config.apiBaseUrl`.
 * Nothing else in the app builds a URL string.
 */
export const endpoints = {
  login: '/auth/login',
  verifyOtp: '/auth/verify-otp',
  resendOtp: '/auth/resend-otp',
  logout: '/auth/logout',
  me: '/auth/me',
  forgotPassword: '/auth/forgot-password',
  resetPassword: '/auth/reset-password',
  changePassword: '/auth/change-password',

  myDocuments: '/my/documents',
  downloadDocument: (slug: string) => `/my/documents/${encodeURIComponent(slug)}/download`,
  downloadDocumentsZip: '/my/documents/download-zip',
  documentViewSession: (slug: string) => `/my/documents/${encodeURIComponent(slug)}/view-session`,
} as const;

/**
 * Endpoints where a 401 means "those credentials were wrong", not "your session
 * expired". The response interceptor must not trigger a global sign-out for
 * these, or a mistyped password would look like a session timeout.
 *
 * The OTP pair belongs here for the same reason and more sharply: a wrong code
 * is the single most likely 401 in the whole app, and treating it as a dead
 * session would clear the user's stored token and bounce them out of a sign-in
 * they were one keystroke from finishing.
 */
export const CREDENTIAL_ENDPOINTS: ReadonlySet<string> = new Set([
  endpoints.login,
  endpoints.verifyOtp,
  endpoints.resendOtp,
  endpoints.forgotPassword,
  endpoints.resetPassword,
]);
